import React, { useState, useEffect } from 'react'
import { Box, Grid, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BsLink } from "react-icons/bs";
import { useProfileContext } from '../ProfileDetailContext';

import { FaFileWord, FaFileImage, FaFileAlt } from 'react-icons/fa';
import { ReactComponent as PdfThumb } from '../../Assets/img/icons/pdf-thumbnail.svg'
import { ReactComponent as DocxThumb } from '../../Assets/img/icons/docx-thumbnail.svg'
import { ReactComponent as PptxThumb } from '../../Assets/img/icons/pptx-thumbnail.svg'
import { ReactComponent as ExcelThumb } from '../../Assets/img/icons/excel-thumbnail.svg'
import { ReactComponent as VideoThumb } from '../../Assets/img/icons/video-thumbnail.svg'
import { ReactComponent as TxtThumb } from '../../Assets/img/icons/txt-thumbnail.svg'
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { ReactComponent as DownloadIcon } from "../../Assets/img/icons/Download-share.svg"

const RootBox = styled(Box)({
  padding: 2,
  borderRadius: 4,
  border: '1px solid #D9D9D9',
  color: "rgb(0, 0, 0, 0.6)"
});

const ThumbnailBox = styled(Box)({
  padding: 2,
  textAlign: 'center',
  overflow: 'hidden',
});

const FileInfoBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'left',
  fontFamily: 'Lato'
});

const ActionsBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
});

const GridItemBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

const PreviewRounded = styled(Box)(({ theme, displaySize }) => ({
  width: displaySize,
  height: displaySize,
  overflow: 'hidden',
  padding: '4px',
  borderRadius: '8px',
  border: '1px solid white',
  cursor: "pointer"
}))

function PreviewFileItem({ file, fontColor, showOnlyIcon = false }) {
  const defaultcolor = fontColor || "white";
  const { openDocumentViewer } = useProfileContext();

  const handleFileClick = (file) => {
    console.log("Opening file:", file);

    if (file?.type == "application/pdf" || file?.name?.toLowerCase().endsWith('.pdf')   ) {
      // window.open(file?.data || file?.document_url, '_blank');
      openDocumentViewer(file);
    } else if (file?.type == "url") {
      // For PDFs, open in a new tab instead of trying to use the modal
      window.open(file?.data || file?.document_url, '_blank');
      console.log("IAM GHERkj askjcnjask c")
      // openDocumentViewer(file);
    } else {
      // For other documents, open in viewer
      openDocumentViewer(file);
    }
  };

  const name = file?.name || file?.document_name;
  const fileType = file?.type || file?.document_type;
  const fileData = file?.data || file?.document_url;

  const [faviconUrl, setFaviconUrl] = useState(null);
  const [faviconFailed, setFaviconFailed] = useState(false);
  const fileName = name === "file" ? "My file" : name;

  // Check if it's a URL
  const isUrl = fileType === 'url';

  useEffect(() => {
    if (isUrl) {
      try {
        const url = new URL(fileData);
        const clearbitFaviconUrl = `https://logo.clearbit.com/${url.hostname}`;
        setFaviconUrl(clearbitFaviconUrl);
        setFaviconFailed(false);
      } catch (error) {
        console.error("Invalid URL:", fileData);
        setFaviconUrl(null);
        setFaviconFailed(true);
      }
    }
  }, [fileData, isUrl]);

  // If showOnlyIcon is true, render only the icon in a clickable container
  if (showOnlyIcon) {
    return (
      <PreviewRounded displaySize="80px" >
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          cursor: 'pointer'
          
        }} onClick={()=>handleFileClick(file)}>
          {isUrl ? (
            faviconUrl && !faviconFailed ? (
              <img
                src={faviconUrl}
                alt="Website Favicon"
                width={40}
                height={40}
                onError={() => setFaviconFailed(true)}
                style={{ objectFit: 'contain' }}
              />
            ) : (
              <OpenInNewRoundedIcon style={{ fontSize: '40px', border:"1px solid red" }} />
            )
          ) : (
            getFileIcon(fileType, fileName)
          )}
        </div>
      </PreviewRounded>
    );
  }

  // Full mode with file details
  return (
    <RootBox>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <GridItemBox>
            <ThumbnailBox>
              {isUrl ? (
                faviconUrl && !faviconFailed ? (
                  <img
                    src={faviconUrl}
                    alt="Website Favicon"
                    width={32}
                    height={32}
                    onError={() => setFaviconFailed(true)}
                  />
                ) : (
                  <OpenInNewRoundedIcon />
                )
              ) : (
                getFileIcon(fileType, fileName)
              )}
            </ThumbnailBox>
          </GridItemBox>
        </Grid>

        <Grid item xs={8}>
          <FileInfoBox>
            <Typography variant="body1" sx={{ color: defaultcolor }}>
              {isUrl ? (
                <a href={fileData} target="_blank" rel="noreferrer">
                  {fileName}
                </a>
              ) : (
                fileName
              )}
            </Typography>
          </FileInfoBox>
        </Grid>

        <Grid item xs={2} className='d-flex'>
          <ActionsBox>
            <IconButton
              sx={{ color: defaultcolor }}
              onClick={handleFileClick}
            >
              <VisibilityIcon sx={{ color: defaultcolor }} />
            </IconButton>
          </ActionsBox>
        </Grid>
      </Grid>
    </RootBox>
  );
}

export default PreviewFileItem;

// export const getFileIcon = (fileType, fileName) => {
//   const extension = fileName.split('.').pop().toLowerCase();
//   if (fileType === 'url') {
//     return <></>
//   } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
//     return <FaFileImage style={{ height: '32px', width: '32px', color: 'green' }} />
//   } else if (['mp4', 'mov', 'avi', 'mpg', 'mpeg'].includes(extension)) {
//     return <VideoThumb style={{ height: '32px', width: '32px' }} />
//   } else if (['pdf'].includes(extension)) {
//     return <PdfThumb style={{ height: '32px', width: '32px' }} />
//   } else if (['doc', 'docx'].includes(extension)) {
//     return <DocxThumb style={{ height: '32px', width: '32px' }} />
//   } else if (['ppt', 'pptx'].includes(extension)) {
//     return <PptxThumb style={{ height: '32px', width: '32px' }} />
//   } else if (['xls', 'xlsx'].includes(extension)) {
//     return <ExcelThumb style={{ height: '32px', width: '32px' }} />
//   } else if (['txt', 'csv'].includes(extension)) {
//     return <TxtThumb style={{ height: '32px', width: '32px' }} />
//   } else
//     return <FaFileAlt style={{ height: '32px', width: '32px' }} />
// }

export const getFileIcon = (fileType, fileName) => {
  if (fileType === 'url') {
    return <></>; // Return early to prevent further execution
  }

  if (!fileName) {
    return <FaFileAlt style={{ height: '32px', width: '32px' }} />; // Default file icon if fileName is null/undefined
  }

  const extension = fileName.split('.').pop().toLowerCase();

  if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
    return <FaFileImage style={{ height: '32px', width: '32px', color: 'green' }} />;
  } else if (['mp4', 'mov', 'avi', 'mpg', 'mpeg'].includes(extension)) {
    return <VideoThumb style={{ height: '32px', width: '32px' }} />;
  } else if (['pdf'].includes(extension)) {
    return <PdfThumb style={{ height: '32px', width: '32px' }} />;
  } else if (['doc', 'docx'].includes(extension)) {
    return <DocxThumb style={{ height: '32px', width: '32px' }} />;
  } else if (['ppt', 'pptx'].includes(extension)) {
    return <PptxThumb style={{ height: '32px', width: '32px' }} />;
  } else if (['xls', 'xlsx'].includes(extension)) {
    return <ExcelThumb style={{ height: '32px', width: '32px' }} />;
  } else if (['txt', 'csv'].includes(extension)) {
    return <TxtThumb style={{ height: '32px', width: '32px' }} />;
  } else {
    return <FaFileAlt style={{ height: '32px', width: '32px' }} />;
  }
};



export const PreviewImage = ({ file, displaySize }) => {
  const { openDocumentViewer } = useProfileContext();

  return (
    <PreviewRounded displaySize={displaySize} onClick={() => openDocumentViewer(file)}>
      <img
        src={file.data}
        alt={file.name}
        className='contain-image-100'
        style={{ borderRadius: '8px' }}
      />
    </PreviewRounded>
  )
}

export const PreviewVideo = ({ file, displaySize }) => {
  const { openDocumentViewer } = useProfileContext();

  return (
    <PreviewRounded displaySize={displaySize} onClick={() => openDocumentViewer(file)}>
      <video
        width="100%"
        height="100%"
        style={{ objectFit: 'cover', borderRadius: '8px' }}
      >
        <source src={file.data} type={file.type} />
        Your browser does not support the video tag.
      </video>
    </PreviewRounded>
  )
}

export const PreviewUrlThumbnail = ({ file, displaySize }) => {

  const [faviconUrl, setFaviconUrl] = useState(null);

  useEffect(() => {
    if (file.type === "url") {
      try {
        const url = new URL(file?.data || file?.document_url);
        const clearbitFaviconUrl = `https://logo.clearbit.com/${url.hostname}`;

        // Set the Clearbit logo URL directly
        setFaviconUrl(clearbitFaviconUrl);
      } catch (error) {
        console.warn("Invalid URL for preview:", file?.data || file?.document_url);
      }
    }
  }, [file]);

  return (
    <a href={file.data} target='_blank' rel='noreferrer'>
      <PreviewRounded displaySize={displaySize}>
        {/* {faviconUrl ? (
          <img src={faviconUrl} alt={file.name} className='cover-image' />
        ) : (
          <OpenInNewRoundedIcon /> // Replace with a placeholder icon if no favicon is available
        )} */}
        <div>
          {file.name}
          <BsLink style={{ fontSize: "60px" }} />
        </div>
      </PreviewRounded>
    </a>
  )
}